// AS TELAS PRINCIPAIS CHEGAM ANTES DE SEREM PEDIDAS (06/10/2026).
//
// Desde a divisão do pacote (dashboard.routes.js), cada tela baixa quando é
// aberta. Para trocar de tela continuar instantâneo, as mais usadas são
// baixadas assim que a primeira tela termina e o navegador fica ocioso — uma
// de cada vez, para não disputar a rede com o que a pessoa está vendo. Com
// "economia de dados" ligada no celular, nada é baixado antes da hora.
// Os caminhos são os MESMOS das rotas: o Vite entrega o mesmo pedaço.
const PRINCIPAIS = [
  () => import('./dashboard/legal/Dashboard.vue'),
  () => import('./dashboard/legal/Index.vue'),
  () => import('./dashboard/legal/FichaDoProcesso.vue'),
  () => import('./dashboard/legal/ClientsIndex.vue'),
  () => import('./dashboard/legal/FichaDoCliente.vue'),
  () => import('./dashboard/legal/PublicationsIndex.vue'),
  () => import('./dashboard/legal/CasesIndex.vue'),
  () => import('./dashboard/financial/Index.vue'),
  () => import('./dashboard/pipeline/PipelineView.vue'),
  () => import('./dashboard/legal/GedIndex.vue'),
  () => import('./dashboard/minutas/MinutasIndex.vue'),
  () => import('./dashboard/correio/CorreioIndex.vue'),
];

const economiaDeDados = () =>
  Boolean(window.navigator?.connection?.saveData) ||
  /(^|-)2g$/.test(window.navigator?.connection?.effectiveType || '');

export const preCarregarTelas = (lista = PRINCIPAIS) => {
  if (typeof window === 'undefined' || economiaDeDados()) return;
  const baixarTodas = () =>
    lista.reduce(
      (anterior, baixar) => anterior.then(() => baixar().catch(() => null)),
      Promise.resolve()
    );
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(baixarTodas, { timeout: 5000 });
  } else {
    setTimeout(baixarTodas, 3000);
  }
};
